import database from "../database/database";
import isNull from "../mixin/isNull";
import {useSearchParams} from "react-router-dom";

export default function () {
    const [searchParams, setSearchParams] = useSearchParams();

    const roles = database.read(database.TABLE_AUTHENTICATION, "roles");
    const username = database.read(database.TABLE_AUTHENTICATION, "username");
    const id = database.read(database.TABLE_AUTHENTICATION, "id");
    const attributes = database.read(database.TABLE_AUTHENTICATION, "attributes");

    if (isNull(roles)) {
        return {
            id: null,
            roles: [],
            username: null,
            attributes: null,
            isDirector: null,
            isOperationalDirector: null
        }
    }

    if (!isNull(searchParams.get("force-admin-auth"))) {
        return {
            id: parseInt(searchParams.get("force-admin-auth")),
            roles: roles,
            username: "intervenant-" + searchParams.get("force-admin-auth"),
            attributes: {
                external_id: parseInt(searchParams.get("force-admin-auth")),
            },
        }
    }

    return {
        id,
        roles,
        username,
        attributes
    };
}
